module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/system/buy-order/buy-order-list/buy-order-list.component.scss
// module id = ./src/app/system/buy-order/buy-order-list/buy-order-list.component.scss
// module chunks = main